import React from 'react';

const LinkAppleAccountSvg = (props) => (
    <svg
        width="253"
        height="141"
        viewBox="0 0 253 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_110_789)">
            <g filter="url(#filter0_dd_110_789)">
                <path
                    d="M70.5 116C96.1812 116 117 95.1812 117 69.5C117 43.8188 96.1812 23 70.5 23C44.8188 23 24 43.8188 24 69.5C24 95.1812 44.8188 116 70.5 116Z"
                    fill="#E9F7C3"
                />
            </g>
            <g filter="url(#filter1_dd_110_789)">
                <path
                    d="M182.5 116C208.181 116 229 95.1812 229 69.5C229 43.8188 208.181 23 182.5 23C156.819 23 136 43.8188 136 69.5C136 95.1812 156.819 116 182.5 116Z"
                    fill="black"
                />
            </g>
            <g filter="url(#filter2_dd_110_789)">
                <path
                    d="M126.5 99C141.688 99 154 86.464 154 71C154 55.536 141.688 43 126.5 43C111.312 43 99 55.536 99 71C99 86.464 111.312 99 126.5 99Z"
                    fill="white"
                />
            </g>
            <path
                d="M119 74V68V66H121H126V68H121V74H126V76H119V75V74ZM130 70H124V72H130V70ZM128 66H133H135V68V74V75V76H128V74H133V68H128V66Z"
                fill="#4B4D63"
            />
            <g clipPath="url(#clip1_110_789)">
                <path
                    d="M83.178 78.1949L69.5202 67.3584C69.2924 67.182 69.527 66.8256 69.7752 66.9675L75.1098 70.0087C77.5272 71.3892 80.5838 70.59 82.0492 68.1957C83.5928 65.67 82.7768 62.345 80.2404 60.8538L72.4136 56.2486C72.1654 56.0998 72.349 55.7193 72.6176 55.8265L76.2148 57.2901C76.2216 57.2935 76.3066 57.3247 76.3406 57.335C76.7214 57.47 77.1328 57.5461 77.5612 57.5461C79.5128 57.5461 81.1142 55.9753 81.2536 54.1069C81.427 51.6919 79.608 50 77.4388 50H60.8128C58.6776 50 56.8858 51.7749 56.913 53.9409C56.9266 55.093 57.4332 56.1206 58.2288 56.8264C58.8272 57.3558 60.8434 58.9993 61.8022 59.7777C61.9722 59.9161 61.877 60.1964 61.656 60.1964H58.3274C54.8288 60.2172 52 63.1096 52 66.6768C52 68.4794 52.7242 70.1091 53.8904 71.282L73.1548 89.9137C74.5182 91.2077 76.3474 92 78.3602 92C82.5796 92 86 88.5193 86 84.2256C86 81.7932 84.8984 79.6204 83.178 78.1949Z"
                    fill="#FF5010"
                />
            </g>
            <path
                d="M190.085 51.5C188.367 51.5868 186.257 52.7849 185.007 54.369C183.874 55.7826 182.898 58.0517 183.171 60.234C185.086 60.4061 187.077 59.1646 188.289 57.5805C189.499 55.9531 190.32 53.7273 190.085 51.5ZM189.934 60.2775C187.252 60.0026 184.687 61.8811 183.326 61.8811C181.965 61.8811 179.866 60.3157 177.651 60.3554C174.735 60.4333 172.053 62.0766 170.537 64.6989C167.544 70.0213 169.799 77.8485 172.752 82.1523C174.19 84.2263 175.94 86.6134 178.194 86.4958C180.371 86.4179 181.187 85.0877 183.831 85.0877C186.436 85.0877 187.213 86.4958 189.506 86.4576C191.838 86.4179 193.316 84.3042 194.754 82.192C196.426 79.7652 197.087 78.8656 197.125 78.748C197.087 78.7084 192.577 75.4996 192.5 70.2947C192.46 65.9115 196.037 63.7993 196.231 63.6817C194.209 60.7081 191.061 60.3157 189.934 60.2775Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_dd_110_789"
                x="0"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_110_789"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_110_789"
                    result="effect2_dropShadow_110_789"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_110_789"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_dd_110_789"
                x="112"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_110_789"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_110_789"
                    result="effect2_dropShadow_110_789"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_110_789"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_dd_110_789"
                x="75"
                y="20"
                width="103"
                height="104"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_110_789"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_110_789"
                    result="effect2_dropShadow_110_789"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_110_789"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_110_789">
                <rect width="253" height="141" fill="white" />
            </clipPath>
            <clipPath id="clip1_110_789">
                <rect
                    width="34"
                    height="42"
                    fill="white"
                    transform="translate(52 50)"
                />
            </clipPath>
        </defs>
    </svg>
);

LinkAppleAccountSvg.displayName = 'LinkAppleAccountSvg';
export default LinkAppleAccountSvg;
